export default {
  // Generic error messages
  networkError: "Грешка во мрежата. Ве молиме проверете ја вашата врска и обидете се повторно.",
  serverError: "Грешка во серверот. Ве молиме контактирајте со поддршката доколку проблемот продолжи.",
  authError: "Сесијата истече. Ве молиме најавете се повторно.",
  validationError: "Невалидни податоци. Ве молиме проверете го внесеното.",
  unknownError: "Се случи неочекувана грешка. Ве молиме обидете се повторно.",

  // Operation-specific errors
  fetchFailed: "Неуспешно вчитување на податоци. Ве молиме обидете се повторно.",
  saveFailed: "Неуспешно зачувување на промените. Ве молиме обидете се повторно.",
  updateFailed: "Неуспешно ажурирање. Ве молиме обидете се повторно.",
  deleteFailed: "Неуспешно бришење. Ве молиме обидете се повторно.",
  createFailed: "Неуспешно креирање. Ве молиме обидете се повторно.",
  publishFailed: "Неуспешно објавување. Ве молиме обидете се повторно.",
  refreshFailed: "Неуспешно освежување. Се прикажуваат претходно вчитаните податоци.",

  // Table state messages
  failedToLoad: "Неуспешно вчитување на податоци",
  failedToLoadHint: "Се случи грешка. Ве молиме обидете се повторно.",
  noData: "Нема достапни податоци",
  noMatch: "Нема соодветни резултати",
  noMatchHint: "Обидете се да ги промените филтрите или пребарувањето.",

  // Common actions
  retry: "Обиди се повторно",
  cancel: "Откажи",
  dismiss: "Затвори",
};
